import React from 'react';

export default [{
  name: 'gulp',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Gulp Boilerplate
      </div>
      <div className='portfolio-item__desc'>
      I released a fresh new version of my Gulp Boilerplate
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-sass"></i>
        <i className="fab fa-gulp"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://medium.com/@geolegaf/a-new-gulp-boilerplate-9349c0d1a39">Blog</a>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/gulp-boilerplate">More</a>
      </div>
    </div>
  )
}, {
  name: 'vuex-boilerplate',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Vuex Boilerplate
      </div>
      <div className='portfolio-item__desc'>
        Boilerplate for VUEX
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-vuejs"></i>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/vuex-boilterplate.git">More</a>
      </div>
    </div>
  )
}, {
  name: 'react-redux-boilerplate',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        React-Redux Boilerplate
      </div>
      <div className='portfolio-item__desc'>
        Boilerplate code setup with community best practices
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-react"></i>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://medium.com/@geolegaf/react-redux-boilerplate-with-best-practices-2fc58115ad05">Blog</a>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/react-redux-boilerplate">More</a>
      </div>
    </div>
  )
}, {
  name: 'npm-module-boilerplate',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        NPM Module Boilerplate
      </div>
      <div className='portfolio-item__desc'>
         Boilerplate plate code to create and publish an NPM package
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-npm"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://medium.com/@geolegaf/publish-your-own-npm-package-84e594b84f36">Blog</a>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/npm-module-boilerplate">More</a>
      </div>
    </div>
  )
}, {
  name: 'responsive-layout',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Responsive Layout
      </div>
      <div className='portfolio-item__desc'>
       A boilerplate for mobile first responsive layout
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-sass"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/responsive-layout.git">More</a>
      </div>
    </div>
  )
}, {
  name: 'css-framework',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Geordize framework
      </div>
      <div className='portfolio-item__desc'>
        My own CSS framework NPM module
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-npm"></i>
        <i className="fab fa-sass"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/Geovica/geordize">More</a>
      </div>
    </div>
  )
}]


// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js